import { render, staticRenderFns } from "./MigrateToOpen360.vue?vue&type=template&id=642d7e06&scoped=true&"
import script from "./MigrateToOpen360.vue?vue&type=script&lang=js&"
export * from "./MigrateToOpen360.vue?vue&type=script&lang=js&"
import style0 from "./MigrateToOpen360.vue?vue&type=style&index=0&id=642d7e06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642d7e06",
  null
  
)

export default component.exports